import React from 'react'
import Richtext from '../atoms/Richtext'
import Image from '../atoms/Image'
import SbEditable from 'storyblok-react'

import FadeInBottomEffect from '../effect/FadeInBottomEffect'

const VerticalTimelineBlock = ({ block, className }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`vertical-timeline-block ${className ? className : ''}`}
      >
        <div className="vertical-timeline-block-content">
          <div className="vertical-timeline-block-wrapper">
            {block.vertical_timeline_block_content?.length > 0 &&
              block.vertical_timeline_block_content.map((item, index) => (
                <article className="vertical-timeline-block-entry" key={index}>
                  <div className="vertical-timeline-block-entry-content">
                    <FadeInBottomEffect
                      className="vertical-timeline-block-entry-content-item"
                      tagName="div"
                    >
                      <Image image={item.image} alt={item.alt} />
                      <Richtext text={item.text} />
                    </FadeInBottomEffect>
                  </div>
                  <div className="vertical-timeline-block-entry-marker">
                    <FadeInBottomEffect
                      className="vertical-timeline-block-entry-marker-item"
                      tagName="div"
                    >
                      <p>{item.date}</p>
                    </FadeInBottomEffect>
                  </div>
                  <div className="vertical-timeline-block-entry-space"></div>
                </article>
              ))}
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default VerticalTimelineBlock
